import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { HeatingModeCard } from './card';
import { HeatingModeProvider } from './provider';
export const HeatingModeView = memo(function HeatingModeView(props) {
    const { config, show_settings, heating_circuit_id, small, children, ...rest } = props;
    return (_jsx(HeatingModeProvider, { config: config, heating_circuit_id: heating_circuit_id, ...rest, children: _jsx(HeatingModeCard, { show_settings: show_settings, heating_circuit_id: heating_circuit_id, small: small }) }));
});
